import React from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { fetchDashboardCountRequest } from "../ipsStore/actions";
import GenericDashboardScreen from "../components/GenericDashboardScreen";
import PatientArrivalsIcon from "../../../assets/images/FlightTickets.svg";
import DashboardBG from "../../../assets/images/Dashboard_bg.svg";

const PatientArrivals = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const handleCardClick = (label) => {
    navigate(
      `/patient_arrivals-patient_list?label=${encodeURIComponent(label)}`,
      {
        state: { label },
      }
    );
  };

  const handleDateFilterApply = (dateRange) => {
    let payload = new FormData();
    payload.append("from_date", dateRange.fromDate);
    payload.append("to_date", dateRange.toDate);
    payload.append("screen", "patient_arrivals");
    payload.append("source", "Web");
    dispatch(fetchDashboardCountRequest(payload));
  };

  return (
    <GenericDashboardScreen
      header="Patient Arrivals"
      screenIcon={PatientArrivalsIcon}
      iconUrl={"/home"}
      showDateFilters={true}
      bgImage={DashboardBG}
      fetchAction={fetchDashboardCountRequest}
      dataSelector={(state) => state.ips.dashboardCount?.patient_arrivals}
      screenName="patient_arrivals"
      handleCardClick={handleCardClick}
      dateFilterHandler={handleDateFilterApply}
    />
  );
};

export default PatientArrivals;
